export default {
    methods: {
        getEligibleEmployeeTypes(contractType) {
            const companyByContractType = this.companiesByContractType.find(c => c.val === contractType) || this.companiesByContractType[0];
            return companyByContractType.eligibleEmployeeTypes;
        }
    },
    computed: {
        companiesByContractType() {
            const { restaurantAdmin, worker, moreRestaurantWorker, canteenWorker, deliveryWorker, deliveryAdmin, companyAdmin, recipient, guest, table, reportWorker, reportGuest, warehouseWorker } = this.employeeTypes;
            return [
                // Ugovor sa keteringom za ishranu radnika
                {
                    val: 1,
                    title: this.$t('company_with_contract'),
                    eligibleEmployeeTypes: [worker, companyAdmin, canteenWorker, recipient]
                },
                // Privatne narudzbe
                {
                    val: 0,
                    title: this.$t('company_without_contract'),
                    eligibleEmployeeTypes: [guest, companyAdmin, reportGuest]
                },
                // Digitalni meni
                {
                    val: 2,
                    title: this.$t('dining_hall'),
                    eligibleEmployeeTypes: [table]
                },
                // B2B - Veleprodaja
                {
                    val: 3,
                    title: this.$t('b2b'),
                    eligibleEmployeeTypes: []
                },
                // Ugovor sa vise restorana za ishranu radnika
                {
                    val: 4,
                    title: this.$t('multi_restaurant_contracts'),
                    eligibleEmployeeTypes: [moreRestaurantWorker, companyAdmin, canteenWorker, recipient]
                },
            ]
        },
        employeeTypes() {
            return {
                restaurantAdmin: { text: this.$t('restaurant'), val: 'restaurant' },
                worker: { text: this.$t('worker'), val: 'customer' },
                moreRestaurantWorker: {
                    text: this.$t('worker_more_restaurants'),
                    val: 'worker_more_restaurants'
                },
                canteenWorker: { text: this.$t('qr_scanner_division'), val: 'payment' },
                deliveryWorker: { text: this.$t('delivery_person'), val: 'dostava' },
                deliveryAdmin: { text: this.$t('admin_delivery'), val: 'admin_delivery' },
                companyAdmin: { text: this.$t('company_admin'), val: 'company' },
                recipient: { text: this.$t('meal_reception_delivery'), val: 'recipient' },
                guest: { text: this.$t('guest'), val: 'guest' },
                table: { text: this.$t('table'), val: 'table' },
                reportWorker: { text: this.$t('reports_worker_orders'), val: 'report' },
                reportGuest: {
                    text: this.$t('reports_guest_orders'), val: 'report_guest',
                },
                warehouseWorker: { text: this.$t('stock'), val: 'warehouse' }
            }
        }
    }
}